// Tools.jsx
import SkillCard from './SkillCard';

const Tools = () => {
  const toolsSkills = [
    { name: 'Git', icon: 'bx bxl-git' },
    { name: 'GitHub', icon: 'bx bxl-github' },
    { name: 'VS Code', icon: 'devicon-vscode-plain' },
    { name: 'Postman', icon: 'devicon-postman-plain' },
    { name: 'Docker', icon: 'bx bxl-docker' },
    { name: 'Figma', icon: 'bx bxl-figma' },
    { name: 'Swagger', icon: 'bx bx-file-blank' },
    { name: 'Vercel', icon: 'devicon-vercel-original' },
    { name: 'Agile/Scrum', icon: 'bx bx-group' },
    { name: 'Documentation', icon: 'bx bx-book' },
  ];

  return (
    <div className="skills__content">
      <div className="skills__content-header">
        <h3 className="skills__title">Tools & Methodologies</h3>
        <p className="skills__description">Development tools, collaboration & best practices</p>
      </div>
      <div className="skills__grid">
        {toolsSkills.map((skill, index) => (
          <SkillCard 
            key={index}
            name={skill.name}
            icon={skill.icon}

          />
        ))}
      </div>
    </div>
  );
};

export default Tools;
